import React from 'react'
import PropTypes from 'prop-types';
import classnames from 'classnames'
import Icon from './Icon'
import style from './valuecard.css';

export default class ValueCard extends React.Component {
  
  static propTypes = {
    style : PropTypes.string,
    value : PropTypes.any,
    name : PropTypes.string,
    icon : PropTypes.object,
    onClick : PropTypes.func,
    valid : PropTypes.bool
  }

  static defaultProps = {
    valid : true
  }

  render() {
    const { name, icon, fontIcon, value, onClick, editable, valid } = this.props
    // const vName = name == null ? null : <div className={style.name}>{name}</div>
    const vValue = ( 
      value == null || value === '' ? 
        <div className={style.noValue}>not set</div> : 
        <div className={style.value}>{value}</div>
    )
    // const vIcon = <Icon icon={icon} className={style.icon} />
    // icon == null ? ( fontIcon == null ? null : <div className={style.fontIcon}><i className={fontIcon}></i></div> ) : 
    //               (typeof icon == 'string' ? <div className={style.icon} style={ { backgroundImage:`url(${icon})` }}></div> : icon )

    const cName = classnames( 
      style.card, 
      style.horizontal,
      style.style1, 
      editable ? style.editable : null, 
      valid ? null : style.invalid 
    )

    return ( 
      <div className={cName} onClick={onClick}>
        {vValue}
      </div>
    )
      
    // return (
    //   <div className={classnames( style.card, style.horizontal, style.style1, editable ? style.editable : null, valid ? null : style.invalid )} onClick={onClick}>
    //     <i className={classnames( 'fa fa-pencil fa-lg', style.editIndicator )} />
    //     {vIcon}
    //     <div className={classnames( style.vertical, style.left )}>
    //       {vName}
    //       {vValue}
    //     </div>
    //   </div>
    // )
  }
}
